import React, { useContext } from 'react';

type ContextType = {
    isBackendSynced: boolean;
    setIsBackendSynced: React.Dispatch<React.SetStateAction<boolean>>;
};

const initialContext: ContextType = {
    isBackendSynced: true,
    setIsBackendSynced: () => {},
};
const BackendSyncedContext = React.createContext<ContextType>(initialContext);

export const useBackendSyncedContext = () => useContext(BackendSyncedContext);

export default BackendSyncedContext;
